import React from 'react';
import { Alert as AntAlert, type AlertProps } from 'antd';

/**
 * The blessed Alert. There is deliberately no styling here: the whole visual restyle lives in the antd
 * bridge (`components.Alert` in `constants/antd.constants`).
 *
 * Icons stay antd's filled set - `es/alert/index.js` reads `iconMapFilled[type]` unconditionally, with
 * no outlined path and no token to redirect it. Call sites wanting outlined pass `icon` themselves.
 */
export type Env0AlertProps = Pick<
  AlertProps,
  | 'message'
  | 'description'
  | 'type'
  | 'icon'
  | 'showIcon'
  | 'banner'
  | 'action'
  | 'closable'
  | 'onClose'
  | 'className'
  | 'style'
> & {
  'data-e2e'?: string;
};

// 66 of the 67 call sites pass showIcon, so it defaults on.
const Alert: React.FC<Env0AlertProps> = ({ showIcon = true, ...props }) => <AntAlert showIcon={showIcon} {...props} />;

export default Alert;
